import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page56() {
  useEffect(() => {
    document.title = "Маяк — Страница 55"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page54" />
        <ForwardLink href="/page56" />
      </div>

      <p style={{ textAlign: "right" }}>55.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ...Нет, ты, должно быть, ослышался.
      </p>
      <p>МОЛОДОЙ подозрительно смотрит на СТАРИКА. СТАРИК отвечает взаимностью.</p>
      <p>КАМЕРА ПОКАЗЫВАЕТ: <u>МОЛОДОЙ тайком кладет в карман СТОЛОВЫЙ НОЖ.</u></p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ПОЗЖЕ ТОЙ ЖЕ НОЧЬЮ</p>
      <p>
        МОЛОДОЙ на полу и наливает себе еще. Рядом с ним<br/>
        стоят ДВЕ ПУСТЫЕ БУТЫЛКИ. Он делает еще один глоток.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, нет, нет. Нет! А я говорю: отвали<br/>
        от меня, говорю.
      </p>
      <p>
        СТАРИК сидит на кровати молодого, уставившись в окно, зацикленный<br/>
        на ужасном ШТОРМЕ, разрывающем хозяйственные постройки на части.<br/>
        У него в руке ПОЧТИ ПУСТАЯ БУТЫЛКА.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Падают. Падают.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Но они никогда не слушали... они<br/>
        никогда... если бы у меня была возможность,<br/>
        они бы никогда -- никто из этих<br/>
        проклятых легкомысленных канадских<br/>
        ублюдков. Бесстыжие трусы. Эти<br/>
        ублюдки не боролись ни с какой революцией -<br/>
        - никогда -- и посмотрите на них! Все
        они трусы и бабы. Черт<br/>
        возьми!
      </p>
      <p>СТАРИК продолжает смотреть в окно.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Карнизы быстро падают.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Никогда! Каждый день ломать спину,<br/>
        работать за двух<br/>
        лошадей, но Уинслоу, Уинслоу... Я<br/>
        сказал этому тупому ублюдку...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да. Эти карнизы скоро исчезнут.
      </p>
      <p style={{ textAlign: "right" }}>55.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page54" />
        <ForwardLink href="/page56" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629138/the-lighthouse-script/venvmmgmcomqcrzli3el.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page56;
